/**
 * useTheme — mode sombre RETIRÉ.
 *
 * Le dark mode produisait un rendu incohérent (écrans partiellement sombres,
 * exercices affichés sur fond blanc éblouissant au milieu d'une page sombre).
 * Décision produit : thème clair uniquement.
 *
 * Ce hook est conservé comme point d'entrée unique : il force le thème clair
 * et nettoie la préférence éventuellement stockée chez les utilisateurs
 * (classe `dark` sur <html> + clé localStorage), pour que personne ne reste
 * bloqué en sombre.
 */

const STORAGE_KEY = "lmm_theme";

function forceLightTheme() {
  if (typeof document === "undefined") return;
  document.documentElement.classList.remove("dark");
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {}
}

// Nettoyage immédiat au chargement du module (avant tout rendu)
forceLightTheme();

export function useTheme() {
  forceLightTheme();
  return {
    theme: "light",
    isDark: false,
    toggleTheme: () => {},
    setTheme: () => {},
  };
}

export default useTheme;
